.title {
    margin: 0 0 1.5rem;
    border-left: 0.5rem solid var(--bs-warning);
    padding-left: 1rem;
    color: var(--bs-primary);
    font-weight: bold;
    & > div {
        font-weight: normal;
    }
}
